<template>
  <Modal
    :title="$t(data.editing ? 'global.dns-zone-srv-record-edit' : 'global.dns-zone-srv-record-add')"
    @close="close"
    @confirm="confirm"
    :hide-footer="true"
  >
    <template #body>
      <DnsZoneSrvRecordForm
        :record-id="data.recordId"
        :dnsZone="data.dnsZone"
        :editing="data.editing"
        :service="data.service"
        :protocol="data.protocol"
        :priority="data.priority"
        :weight="data.weight"
        :port="data.port"
        :target="data.target"
        :ttl="data.ttl"
        v-on="$listeners"
      />
    </template>
  </Modal>
</template>

<script>
import DnsZoneSrvRecordForm from "@/components/smart/forms/DnsZoneSrvRecordForm";
import Modal from "@/components/display/Modal";

export default {
  name: "DnsZoneSrvRecordModal",
  props: {
    data: Object,
  },
  components: {
    DnsZoneSrvRecordForm,
    Modal,
  },
  setup(props, { emit }) {
    const close = () => emit("close");
    const confirm = () => emit("confirm");

    return {
      close,
      confirm,
    };
  },
};
</script>
